export const INITIAL_VALUES = {
  value: '',
  dirty: false,
  error: '',
  hasError: true
}
